import React from 'react';
import Fullwidth from '@ajat/design-system/ContentBlocks/Fullwidth';
import { ComponentPage, DemoCard } from '../../shared';
import { HERO_IMAGE } from './contentDemoData';

export const meta = {
  component: Fullwidth,
  title: 'Fullwidth',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/Fullwidth',
  description:
    'Editorial storytelling block — eyebrow, a large statement, supporting copy, USP tags and a link, with an optional wide image. Every slot is toggleable, so the same component covers the image-led story and the plain USP strip.',
  props: [
    ['showImage', 'bool', 'true', 'Show the image'],
    ['showSubtitle', 'bool', 'true', 'Show the eyebrow'],
    ['showMainCopy', 'bool', 'true', 'Show the main statement'],
    ['showTags', 'bool', 'true', 'Show the tag row'],
    ['showHyperlink', 'bool', 'true', 'Show the link'],
    ['mainCopyVariant', "'h2' | 'h3'", "'h3'", 'Typographic size of the main statement'],
    ['image', 'string', 'null', 'Wide image'],
    ['imageAlt', 'string', "''", 'Alt text'],
    ['subtitle', 'string', "''", 'Eyebrow (typo-h5)'],
    ['mainCopy', 'string', "''", 'Main statement'],
    ['additionalCopy', 'string', "''", 'Supporting paragraph'],
    ['tags', 'array', '[]', 'Strings rendered as USP tags'],
    ['hyperlinkLabel', 'string', "'Discover More'", 'Link label'],
    ['hyperlinkHref', 'string', "'#'", 'Link target'],
    ['onHyperlinkClick', 'func', '—', 'Link handler'],
    ['backgroundColor', 'string', 'null', 'Section background colour'],
    ['paddingTop', 'string', 'null', 'Section top padding: a DS spacing token name (e.g. medium-l) or any CSS length; null keeps large-m'],
    ['paddingBottom', 'string', 'null', 'Section bottom padding: a DS spacing token name or any CSS length; null keeps large-m'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'Story block',
      code: `import Fullwidth from '@ajat/design-system/ContentBlocks/Fullwidth';

<Fullwidth
  image={storyImage}
  imageAlt="Vores kollektion"
  subtitle="STUDENT CLUB"
  mainCopy="ABC-Gruppen har levererat kläder till skolor i över 20 år."
  additionalCopy="Alla plagg har genomgått gedigna tester …"
  tags={['Premium Quality', 'Custom Design', 'Fast Delivery']}
  hyperlinkLabel="Discover More"
  hyperlinkHref="/clothing/abc-se/faq"
/>`,
    },
  ],
};

export default function FullwidthPage() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="All sections" flush>
        <Fullwidth
          image={HERO_IMAGE}
          imageAlt="Studietur collection"
          subtitle="STUDENT CLUB"
          mainCopy="ABC-Gruppen har levererat kläder till skolor och föreningar i över 20 år. Fokus har alltid legat på kvalité och enkelhet för kunden."
          additionalCopy="Alla plagg som ingår i vår kollektion har genomgått gedigna tester för att säkerställa att de håller våra högt uppsatta kvalitetskrav, tvätt efter tvätt."
          tags={['Premium Quality', 'Custom Design', 'Fast Delivery']}
          hyperlinkLabel="Discover More"
          hyperlinkHref="#"
        />
      </DemoCard>

      <DemoCard title="Without an image" flush>
        <Fullwidth
          showImage={false}
          subtitle="OUR MISSION"
          mainCopy="We create high-quality clothing for schools and organizations."
          additionalCopy="Every piece goes through rigorous quality testing to ensure durability across washes."
          tags={['Sustainable', 'Ethical', 'Local Production']}
          hyperlinkLabel="Learn More"
        />
      </DemoCard>

      <DemoCard title="Minimal" hint="eyebrow and statement only" flush>
        <Fullwidth
          showImage={false}
          showTags={false}
          showHyperlink={false}
          subtitle="ABOUT US"
          mainCopy="More than 75,000 customers annually trust us with their school clothing."
        />
      </DemoCard>

      <DemoCard title="Custom background colour" flush>
        <Fullwidth
          showImage={false}
          backgroundColor="var(--color-gray-025)"
          subtitle="FEATURED"
          mainCopy="Discover our latest collection of custom school apparel."
          tags={['New Arrivals', 'Best Sellers']}
          hyperlinkLabel="Shop Now"
        />
      </DemoCard>
    </ComponentPage>
  );
}
